module.exports = __webpack_public_path__ + "static/media/back-one.8057f5e2.png";